<div class="row">
  <div class="col-4">
    <label>Part Name</label>
    <input type='text' class='form-control' [(ngModel)]='this.part.name' [class.is-valid]='part.name !== ""' [class.is-invalid]='part.name === ""'/>
  </div>
  <div class="col-4">
    <label>Part Category</label>
    <select
      class='form-control'
      [class.is-valid]='this.part.partCategoryId > 0'
      [class.is-invalid]='this.part.partCategoryId === -1'
      (change)='this.changeCat($event)'
      >
      <option value='-1'>Select a Category</option>
      @for (item of this.partCat; track item) {
        <option [value]='item.id' [selected]='this.part.partCategoryId === item.id'>
          {{ item.name }}
        </option>
      }
    </select>
  </div>
  <div class="col-4">
    <label>Manufacturer</label>
    <input type='text' class='form-control' [(ngModel)]='this.part.manufacturer' [class.is-valid]='part.manufacturer !== ""' [class.is-invalid]='part.manufacturer === ""'/>
  </div>
  <div class="col-4">
    <label>Model</label>
    <input type='text' class='form-control' [(ngModel)]='this.part.model'/>
  </div>
  <div class="col-12">
    <label>Description</label>
    <textarea class='form-control' [(ngModel)]='this.part.description'></textarea>
  </div>
  <div class="col-4">
    <label>SKU</label>
    <input type='text' class='form-control' [(ngModel)]='this.part.sku'/>
  </div>
  <div class="col-4">
    <label>Manufacturer Part Number</label>
    <input type='text' class='form-control' [(ngModel)]='this.part.manufacturerPartNumber'/>
  </div>
  <div class="col-4">
    <label>EAN</label>
    <input type='text' class='form-control' [(ngModel)]='this.part.eanNumber'/>
  </div>
  <div class="col-4">
    <label>Quantity</label>
    <input type='number' class='form-control' [(ngModel)]='this.part.qty' [class.is-valid]='part.qty >= 0' [class.is-invalid]='part.qty < 0'/>
  </div>
  <div class="col-4">
    <label>Cost</label>
    <div class='input-group'>
      <div class='input-group-prepend'>
        <span class='input-group-text'>£</span>
      </div>
      <input type='number' class='form-control' [(ngModel)]='this.part.value' [class.is-valid]='part.value >= 0' [class.is-invalid]='part.value < 0'/>
    </div>
  </div>
  <div class="col-4">
    <label>Depot / Stock Location</label>
    <select
      class='form-control'
      (change)='this.changeDepot($event)'
      >
      <option value='-1'>Select a Depot</option>
      @for (item of this.depots; track item) {
        <option [value]='item.id' [selected]='this.part.depotId === item.id'>
          {{ item.name }}
        </option>
      }
    </select>
  </div>
</div>
